export const sendgrid = {
  "apiKey": "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"
};